export const sendgrid = {
  "apiKey": "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"
};